import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Grid,
  TextField,
  MenuItem,
  Button,
  Divider,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import "../Components/promotion.css";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import { fExecuteAPI } from "../../../Server/Apis";
import {
  exportToExcel,
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fKeyTabInput,
  hasNonEnterStatus,
} from "../../../Utility/Utilitys";
import {
  Items_Search_PAP_GetRowApi,
  PAP_Items_DeleteApi,
  PAP_ITEMS_GetrowApi,
  PAP_ITEMS_UpdateApi,
  RSP_Status_GETROW,
} from "../../../Server/ApiV2";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";

const ItemSelectionModal = ({
  open,
  onClose,
    selectedRow,
  data,
  setIsPopModalDataChanged,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        document.getElementsByName("ItmName")[0]?.focus();
      }, 200);
      fGetRow();
    }
  }, [open]);

  const cnType = ["-", "CN-Sellout-Qty", "RBT-Sellout-Qty", "Fixed-Support"];
  const promoTyp = ["Flyer", "Loyalty", "X & Y"];

  let initObj = {
    SrNo: 0,
    ItmCode: "",
    ItmName: "",
    ItmNameFlyer: "",
    Unit: "",
    Curstk: 0,
    Consm: 0,
    CostPrice: 0,
    Lprate: 0,
    RSP: 0,
    RSPWithVat: 0,
    PromoRSP: 0,
    PromoRSPWithVat: 0,
    CutPrice: 0,
    QtyPerPromotion:0,
    CNType: "-",
    CNAmount: 0,
    GPPerc: "",
    Vendor: "",
    VendorCd: "",
    PromoTyp: "Flyer",
    Remarks: "",
  };
  const [bufferObj, setBufferObj] = useState(initObj);

  const [sUnit, setUnit] = useState([]);
  const [sDetailData, setDetailData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

   const fKeyTabInputId = (e, nextId) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setTimeout(() => {
        document.getElementById(nextId)?.focus();
      }, 150);
    }
  };


  const handleDetailChange = (field, value) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleDetailChangeFlyer = (field, value) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const fNew = () => {
    setBufferObj(initObj);
    setErrors(initHeadError);
    setTimeout(() => {
      document.getElementsByName("ItmName")[0]?.focus();
    }, 400);
  };
  const fSave = async () => {
    setErrors(initHeadError);
    let validation = fValidationHead();
    if (!validation) return;

    const obj = {
      TransId: data?.TransId,
      PageId: selectedRow?.PageId,
      SrNo: selectedRow?.SrNo,
      ItmCode: bufferObj.ItmCode,
      Unit: bufferObj.Unit,
      Consm: bufferObj.Consm,
      CostPrice: bufferObj.CostPrice,
      Lprate: bufferObj.Lprate,
      RSP: bufferObj.RSP,
      RSPWithVat: bufferObj.RSPWithVat,
      PromoRSP: bufferObj.PromoRSP,
      PromoRSPWithVat: bufferObj.PromoRSPWithVat,
      CutPrice: bufferObj.CutPrice,
      QtyPerPromotion: bufferObj.QtyPerPromotion,
      CNType: bufferObj.CNType === "-" ? "" : bufferObj.CNType,
      CNAmount: Number(bufferObj.CNAmount),
      Vendor: bufferObj.VendorCd,
      PromoTyp: bufferObj.PromoTyp,
      Remarks: bufferObj.Remarks,
      Curstk: bufferObj.Curstk,
      ItmNameFlyer: bufferObj?.ItmNameFlyer,
    };

    const res = await PAP_ITEMS_UpdateApi(obj);

    if (res.status === 200) {
      fAlertToast("SUCCESS", "Line items saved successfully");
      fNew();
      fGetRow();
      setIsPopModalDataChanged(true);
    }
  };
  const apiRef = useGridApiRef();
     const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };

  const handlePromoRspKeyUp = (e) => {
    const input = e.target.value;

    // allow ".", "", etc. while typing
    if (input === "" || input === ".") return;

    const promoRspValue = parseFloat(input);
    if (isNaN(promoRspValue) || !bufferObj.Unit) return;

    const selectedUnit = sUnit.find((unit) => unit.UOM === bufferObj.Unit);
    if (!selectedUnit) return;

    const taxAmount = (selectedUnit.TaxPerc / 100) * promoRspValue;
    const proRSPVAT = promoRspValue + taxAmount + selectedUnit.AddiCessAmt;

    setBufferObj((prevOrder) => ({
      ...prevOrder,
      PromoRSP: input, // keep original string
      PromoRSPWithVat: proRSPVAT.toFixed(2),
    }));
  };

  const handlePromoRspVATKeyUp = (e) => {
    const input = e.target.value;

    if (input === "" || input === ".") return;

    const rspVAT = parseFloat(input);
    if (isNaN(rspVAT) || !bufferObj.Unit) return;

    const selectedUnit = sUnit.find((unit) => unit.UOM === bufferObj.Unit);
    if (!selectedUnit) return;

    const proRspVAT = rspVAT - selectedUnit.AddiCessAmt;
    const promoRSPVAT = (proRspVAT / (100 + selectedUnit.TaxPerc)) * 100;

    setBufferObj((prevOrder) => ({
      ...prevOrder,
      PromoRSPWithVat: input,
      PromoRSP: promoRSPVAT.toFixed(4),
    }));
  };

  let initHeadError = {
    SrNo: "",
    ItmCode: "",
    ItmName: "",
    ItmNameFlyer: "", //new
    Unit: "",
    Consm: "",
    CostPrice: "",
    Lprate: "",
    RSP: "",
    RSPWithVat: "",
    PromoRSP: "",
    PromoRSPWithVat: "",
    Curstk: "",
    CutPrice: "",
    QtyPerPromotion: "",
    CNType: "",
    CNAmount: "",
    Vendor: "",
    VendorCd: "",
    PromoTyp: "",
    Remarks: "",
  };
  const [errors, setErrors] = useState(initHeadError);

  const fGetRow = async () => {
    const res = await PAP_ITEMS_GetrowApi({
      TransId: data?.TransId,
      PageId: selectedRow?.PageId,
      SrNo: selectedRow?.SrNo,
    });
    if (res.status === 200) {
      if (res?.data?.recordset?.length > 0) {
        setDetailData(res?.data?.recordset ?? []);
      }
    }
  };

  const fValidationHead = () => {
    let isValid = true;
    const newError = initHeadError;

     const iItmCode = bufferObj?.ItmCode ?? "";
    if (iItmCode == "") {
      newError.ItmCode = "Qty/Inv is required.";
      isValid = false;
    }

    const iItmName = bufferObj?.ItmName ?? "";
    if (iItmName == "") {
      newError.ItmName = "Qty/Inv is required.";
      isValid = false;
    }


   const iUnit = bufferObj?.Unit ?? "";
    if (iUnit == "") {
      newError.Unit = "Qty/Inv is required.";
      isValid = false;
    }

  const iPromoRSP = bufferObj?.PromoRSP ?? "";
    if (iPromoRSP == "") {
      newError.PromoRSP = "Qty/Inv is required.";
      isValid = false;
    }

     const PromoRSPVat = bufferObj?.PromoRSPWithVat ?? "";
    if (PromoRSPVat == "") {
      newError.PromoRSPWithVat = "Qty/Inv is required.";
      isValid = false;
    }

   const Cutprice = bufferObj?.CutPrice ?? "";
    if (Cutprice == "") {
      newError.CutPrice = "CutPrice is required.";
      isValid = false;
    }

    const QtyPer = bufferObj?.QtyPerPromotion ?? "";
    if (QtyPer == "") {
      newError.QtyPerPromotion = "Qty/Inv is required.";
      isValid = false;
    }

    const ipromoTyp = bufferObj?.PromoTyp?.trim?.() ?? "";

    if (ipromoTyp == "") {
      newError.PromoTyp = "Promo Type is required.";
      isValid = false;
    }

    setErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Unit")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);

  const GetSearchItem = async (
    xData,
    xCategory,
    xBrand,
    xPacking,
    xLoc,
    xType,
    setSearchGridData
  ) => {
    let vSeatchVendor = {
      Data: xData,
      Category: xCategory,
      Brand: xBrand,
      Packing: xPacking,
      Loc: xLoc,
      Type: xType,
    };
    const vItemSearch = await Items_Search_PAP_GetRowApi(vSeatchVendor);

    console.log(vItemSearch);
    if (vItemSearch?.status === 200) {
      if (vItemSearch?.data?.recordset.length > 0) {
        let vItemSearchArr = vItemSearch?.data?.recordset?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setSearchGridData(vItemSearchArr);
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch?.data?.message
          ? vItemSearch?.data?.message
          : "Error in SearchItem"
      );
    }
  };

  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: bufferObj?.ItmName,
    }));

    if (bufferObj?.ItmName != "") {
      GetSearchItem(
        bufferObj?.ItmName,
        selectedRow?.Category,
        selectedRow?.Brand || "",
        "", // selectedRow?.Packing,
        data?.TransLoc,
        "Any",
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const GetUnitArr = async (xItemCode, loaderScreen = true, defUnit) => {
    try {
      const response = await fExecuteAPI(
        "GETITEMUNITS_GETROW",
        { itemCd: xItemCode },
        loaderScreen
      );

      if (response?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error("Error in fetching units");
      }

      const units = response?.ResultSet || [];
      if (!units.length) return [];

      setUnit(units);
      const defaultUnit =
        defUnit && units.some((u) => u.UOM === defUnit)
          ? defUnit
          : units[0]?.UOM;

      setBufferObj((prev) => ({
        ...prev,
        Unit: defaultUnit,
      }));

      await getCostPrice(xItemCode, defaultUnit);

      return units;
    } catch (error) {
      fAlertToast("FAILED", error.message);
      return [];
    }
  };

  const getCostPrice = async (itemCd, unitId) => {
    try {
      const response = await RSP_Status_GETROW({
        ItmCd: itemCd,
        UnitId: unitId,
        Loc: data?.TransLoc,
      });

      if (response?.data?.Type?.toUpperCase() !== "SUCCESS") {
        throw new Error(response?.message || "Error in fetching Cost Price");
      }

      const obj = response.data?.ResultSet[0];

      setBufferObj((prev) => ({
        ...prev,
        RSP: obj?.RSP?.toFixed(2),
        RSPWithVat: obj?.VATRSP === null ? 0 : obj?.VATRSP?.toFixed(2),
        CostPrice: obj?.CostPr?.toFixed(2),
        Lprate: obj?.LPRate?.toFixed(2),
      }));

      setTimeout(() => {
        document.getElementsByName("ItmNameFlyer")[0]?.focus();
      }, 400);
    } catch (error) {
      fAlertToast("FAILED", error.message);
    }
  };

  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet.length > 0) {
        return vItemSearchFull?.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const handleItemSelection = async (ItmCd, Name1, DefUnit = "", xConsm) => {
    setBufferObj((prev) => ({
      ...prev,
      ItmCode: ItmCd,
      ItmName: Name1,
      ItmNameFlyer: Name1, //new
      Consm: xConsm,
    }));

    await GetUnitArr(ItmCd, true, DefUnit);
    //setSearchModal(false);
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        bufferObj?.ItmName,
        data?.TransLoc
      );

      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1,
          vItemSearchFull[0]?.DefUnit,
          vItemSearchFull[0]?.CONSM
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (
      e.key === "Backspace" &&
      bufferObj?.ItmCode &&
      bufferObj?.ItmName === ""
    ) {
      setBufferObj((prev) => ({
        ...prev,
        ItmCode: "",
        ItmName: "",
        ItmNameFlyer: "",
      }));
    }
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        selectedRow?.Category,
        selectedRow?.Brand || "",
        "", // selectedRow?.Packing,
        data?.TransLoc,
        sItemSearchDropdownObj.Type,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1, "", e?.row?.CONSM);
    setItemToggleDropdown(false);
  };

  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGC_Toggle_Head_Customer_ToggleDropDowm(false);
        }
      }

      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm, sItemToggleDropdown]);

  //vendor start

  //2nd call

  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: bufferObj.Vendor,
      }));
      if (bufferObj.VendorName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          bufferObj.Vendor,
          "Any",
          "C",
          "N",
          data?.TransLoc
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Unit")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  //1st call

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);

      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  const fOnKeyUpVendor = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        bufferObj.Vendor,
        "Any",
        "C",
        "Y",
        data?.TransLoc
      );
      if (vExactSearch.length > 0) {
        setBufferObj((prev) => ({
          ...prev,
          VendorCd: vExactSearch[0]?.AcCd,
          Vendor: vExactSearch[0]?.Name1,
        }));
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
    }
    if (e.key === "Backspace" && bufferObj.Vendor) {
      setBufferObj((prev) => ({
        ...prev,
        VendorCd: "",
      }));
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        data?.TransLoc
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
        setBufferObj((prev) => ({
          ...prev,
          VendorCd: vExactSearch[0]?.AcCd,
          Vendor: vExactSearch[0]?.Name1,
        }));
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const Get_ToggleDropDown_Load = async (
    xData = bufferObj?.Vendor,
    xType = "Any",
    xAcTyp = "C",
    xExact = "Y",
    A_Loc = data?.TransLoc
  ) => {
    let vLoaded_Cost_FreightObj = {
      Data: xData,
      Type: xType,
      Loc: A_Loc,
      AcTyp: xAcTyp,
      Exact: xExact,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
    const vLandedCostDropdownSearch = await fExecuteAPI(
      "AccountTransSearch_GETROW",
      FinalObj
    );
    if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
      let GridID = [];
      if (vLandedCostDropdownSearch?.ResultSet.length > 0) {
        let GridID = vLandedCostDropdownSearch?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        return GridID;
      } else {
        return GridID;
      }
    } else {
      fAlertToast("FAILED", "Error in loading LandedCost Api");
      return [];
    }
  };

 const columns = [
    {
  field: "Delete",
  headerName: "Delete",
  width: 70,
  align: "center",
  headerAlign: "center",
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <Tooltip title="Delete">
      <IconButton
        size="small"
        color="error"
        onClick={(e) => {
          e.stopPropagation(); 
          handleDelete(params.row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  ),
},
  { field: "ItmCode", headerName: "Item Code", width: 85 },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 220, 
  },
  { field: "ItmNameFlyer", headerName: "ItemName(Flyer)", width: 110, renderCell: (params) => (
    <Tooltip title={params.row?.ItmNameFlyer}>
      <span>{params.row?.ItmNameFlyer == 0 ? "":params.row?.ItmNameFlyer}</span>
    </Tooltip>
  )},
  { field: "Unit", headerName: "Unit", width: 78 },
  { field: "UnitName", headerName: "UnitName", width: 78 },
  { field: "Consm", headerName: "Consm", width: 64, align: "right",headerAlign: "right" },
  { field: "CurStk", headerName: "Stock", width: 70,align:"center",headerAlign: "center" },
  { field: "CostPrice", headerName: "Cost.Pr", width: 70, align: "right",headerAlign: "right" },
  { field: "Lprate", headerName: "LP.Rate", width: 70, align: "right",headerAlign: "right" },
  { field: "RSP", headerName: "RSP", width: 60, align: "right",headerAlign: "right" },
  { field: "RSPWithVat", headerName: "RSP-VAT", width: 74, align: "right",headerAlign: "right" },
  { field: "CutPrice", headerName: "Cut.Price", width: 75, align: "right",headerAlign: "right" },
  { field: "CutPricePerc", headerName: "Cut.Price%", width:85, align: "right",headerAlign: "right" },
  { field: "DiscountPerc", headerName: "Disc.%", width: 60, align: "right",headerAlign: "right" },
  { field: "DiscountAmount", headerName: "Disc.Amt", width: 79, align: "right",headerAlign: "right" },
  { field: "PromoRSP", headerName: "Promo.RSP", width: 90, align: "right",headerAlign: "right" },
  { field: "PromoRSPWithVat", headerName: "Promo.RSP-VAT", width: 95, align: "right",headerAlign: "right" },
  { field: "SavingAmount", headerName: "Saving.Amt", width: 80,align:"center",headerAlign: "center" },
  { field: "GPAmount", headerName: "GP.Amt", width: 60, align: "right",headerAlign: "right" },
  { field: "GPPerc", headerName: "GP%", width: 60, align: "right" , headerAlign: "right"},
  { field: "QtyPerPromotion", headerName: "Qty/Inv", width: 80,headerAlign: "right" },
  { field: "CNType", headerName: "CN.Type", width: 110, width: 80, align: "left" , headerAlign: "left" },
  { field: "CNAmount", headerName: "CN.Amt", width: 90, align: "center",headerAlign: "center" },
  { field: "VendorName", headerName: "Vendor", width: 120, align: "left",headerAlign: "left"   },
  { field: "PromoTyp", headerName: "Type", width: 110 , align: "left",headerAlign: "left" },
  { field: "Remarks", headerName: "Remarks", width: 130 , align: "left",headerAlign: "left"},
];
  const handleRowClick = async (row) => {
    setErrors(initHeadError);
    setBufferObj((prev) => ({
      ...prev,
      ...row,
      VendorCd: row.Vendor,
      Vendor: row.VendorName,
      CNType: row.CNType === "" ? "-" : row.CNType,
    }));
    await GetUnitArr(row.ItmCode, true, row.Unit);

    setTimeout(() => {
      document.getElementsByName("ItmName")[0]?.focus();
    }, 600);
  };

  const fClose = () => {
    fNew();
    onClose();
    setItemToggleDropdown(false);
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    setDetailData([]);
  };

const handleDelete = (row) => {
  confirmAlert({
    title: "Delete",
    message: "Are you sure you want to delete this promotion?",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          try {
            const payload = {
              TransId: row.TransId,
              PageId: row.PageId,
              SrNo: row.SrNo,
              ItmCode: row.ItmCode,
              Unit: row.Unit,
            };

            const res = await PAP_Items_DeleteApi(payload);

            if (res?.status === 200) {
              fAlertToast("SUCCESS", "Deleted successfully");
              fGetRow();
            } else {
              fAlertToast("FAILED", res?.data?.message || "Delete failed");
            }
          } catch (err) { }
        },
      },
    ],
  });
};


  const Pill = ({ label, value }) => {
    const theme = useTheme();
    return (
      <Chip
        variant="outlined"
        size="small"
        label={
          <Typography
            variant="caption"
            component="span"
            sx={{ fontWeight: 600 }}
          >
            <span style={{ color: theme.palette.primary.main }}>{label}</span>{" "}
            <span style={{ color: "#334155" }}>{value}</span>
          </Typography>
        }
        // sx={{ bgcolor: "background.paper" }}
      />
    );
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          width: vMediaQuery ? "100%" : "95%",
          height: vMediaQuery ? "100vh" : "85vh",
          borderRadius: 2,
          boxShadow: 24,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "white",
            py: vMediaQuery ? 0 : 0.5,
            px: vMediaQuery ? 1.5 : 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Item Selection</Typography>
          <IconButton
            className="itemSearch"
            onClick={fClose}
            sx={{ background: "#ffffff38 !important" }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>

        {/* CONTENT */}
        <Box sx={{ p: vMediaQuery ? 1 : 3, overflowY: "auto" }}>
          <Box
            sx={{
              p: 1,
              mx: vMediaQuery ? 0 : 3,
              background: "linear-gradient(135deg, #fbfcff 0%, #ebf3ff 100%)",
              border: `1px solid rgba(33, 150, 243, 0.3)`,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  <Pill label="Trans ID :" value={data?.TransId || "-"} />
                  <Pill
                    label="Date :"
                    value={moment(data?.TransDt).format("DD/MM/YYYY") || "-"}
                  />
                  <Pill label="Loc :" value={data?.TransLocName || "-"} />
                  <Pill label="Promo Title :" value={data?.PromoTitle || "-"} />
                </Box>
              </Grid>
              <Grid item xs={12} md={12} className="itemhead">
                <Grid
                  container
                  rowSpacing={{ xs: 0, sm: 0, md: 1, lg: 2 }}
                  columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 3 }}
                >
                  <Grid item xs={12} md={6} lg={3}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={3.2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Page
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={8.3}>
                        <TextField
                          variant="standard"
                          fullWidth
                          // disabled
                          autoComplete="off"
                          value={selectedRow?.PageId}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4.5}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Category
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={9.5}>
                        <TextField
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          // disabled
                          value={`${selectedRow?.Category} - ${selectedRow?.CategoryName}`}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4.5}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Sub Group
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={9.5}>
                        <TextField
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          // disabled
                          value={`${selectedRow?.SubGrp} - ${selectedRow?.SubGrpName}`}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={3.2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Main Group
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={8.3}>
                        <TextField
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          // disabled
                          value={`${selectedRow?.MainGrp} - ${selectedRow?.MainGrpName}`}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4.5}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Brand
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={9.5}>
                        <TextField
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          // disabled
                          value={
                            selectedRow?.Brand === "" ||
                            selectedRow?.BrandName === ""
                              ? ""
                              : `${selectedRow?.Brand} - ${selectedRow?.BrandName}`
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4.5}>
                    <Grid container>
                      <Grid item xs={3} sm={2} md={2.2} lg={2}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          Packing
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={0.5} md={0.5} lg={0.5}>
                        <Typography
                          variant="subtitle2"
                          color={"primary.main"}
                          fontWeight={600}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={9.5} md={9.3} lg={9.5}>
                        <TextField
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          // disabled
                          value={selectedRow?.Packing}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* ITEM INPUTS */}
          <Box
            className="itemSearch"
            sx={{
              border: 0.5,
              borderColor: "#c0def3",
              boxShadow: 0,
              p: vMediaQuery ? 1 : 2,

              borderRadius: 1,
              backgroundColor: "#f7f7f7ad",
            }}
          >
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 1.2, md: 1, lg: 2 }}
              rowSpacing={{ xs: 1, sm: 1.6, md: 2, lg: 2 }}
            >
              <Grid item xs={4} sm={1.8} md={2} lg={1.2}>
                <TextField
                  fullWidth
                  label="Item Code"
                  size="small"
                  disabled
                  value={bufferObj?.ItmCode}
                  onChange={(e) =>
                    handleDetailChange("ItmCode", e.target.value)
                  }
                  error={errors.ItmCode === "" ? false : true}
                  helperText={errors.ItmCode}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={8} sm={5.7} md={4.8} lg={3.8}>
                <GCToggleSearchV1
                  xLabelText="Item Name"
                  xName="ItmName"
                  xType="text"
                  xtabIndex="1"
                  xReadOnly={false}
                  xValue={bufferObj?.ItmName}
                  xOnChange={(e) => {
                    const value = e.target.value;

                    setBufferObj((prev) => ({
                      ...prev,
                      ItmCode: "",
                      ItmName: value,
                      ItmNameFlyer: "",
                      Consm: 0,
                      CostPrice: 0,
                      Lprate: 0,
                      RSP: 0,
                      RSPWithVat: 0,
                      DiscountPerc: 0,
                      DiscountAmount: 0,
                      PromoRSP: 0,
                      PromoRSPWithVat: 0,
                    }));

                    setUnit([]);
                    handleDetailChange("ItmName", value);
                  }}
                  xOnKeyUp={fItemSearchKey}
                  xonClickbtn={fItemSearchKey}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  xrows={sGridSelectRowData}
                  xcolumns={[
                    { field: "id", headerName: "ID", width: 70, hide: true },
                    { field: "ItmCd", headerName: "Code", width: 90 },
                    { field: "Name1", headerName: "Name", flex: 1 },
                  ]}
                  xRowClick={fGCToggleItemOnRowClick}
                  xRowCellClick={fGCToggleItemOnCellKeyDown}
                  xToggle={sItemToggleDropdown}
                  xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
                  xOnChangeDropdownInput={fOnChangeItem}
                  xDropdownObj={sItemSearchDropdownObj}
                  xOnKeyUpDropdownInput={fOnKeyUpItem}
                  xError={errors.ItmName === "" ? false : true}
                  xErrorMessage={errors.ItmName}
                />
              </Grid>
              <Grid item xs={8} sm={4.4} md={5.2} lg={3}>
                <TextField
                  fullWidth
                  label="ItemName (Flyer)"
                  name="ItmNameFlyer"
                  size="small"
                  autoComplete="off"
                  value={bufferObj?.ItmNameFlyer || ""}
                  error={!!errors.ItmName}
                  helperText={errors.ItmName}
                  onKeyDown={(e) => {
    fKeyTabInputId(e, "Unit");
  }}
                  onFocus={fContent_Focus}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBufferObj((prev) => ({
                      ...prev,
                      ItmNameFlyer: value,
                      Unit: prev.Unit || "", 
                      
                    }));
                    handleDetailChangeFlyer("ItmNameFlyer", value);
                  }}
                  
                />
              </Grid>

              <Grid item xs={4} sm={2.1} md={2.2} lg={1.3}>
                <TextField
                  fullWidth
                  label="Unit"
                  name="Unit"
                  id="Unit"
                  select
                  size="small"
                  value={bufferObj?.Unit}
                  defaultValue=""
                   onKeyDown={(e) => {
                    fKeyTabInput(e, "PromoRSP");
                  }}
                  onChange={(e) => {
                    setBufferObj((prevV) => ({
                      ...prevV,
                      Unit: e.target.value,
                    }));
                    getCostPrice(bufferObj?.ItmCode, e.target.value);
                  }}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.Unit === "" ? false : true}
                  helperText={errors.Unit}
                >
                  {sUnit.map((val) => (
                    <MenuItem key={val.UOM} value={val.UOM}>
                      {val?.Name1}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4} sm={2} md={1.4} lg={0.9}>
                <TextField
                  fullWidth
                  label="Cost.PR"
                  size="small"
                  name="CostPrice"
                  disabled
                  value={bufferObj?.CostPrice}
                  onChange={(e) =>
                    handleDetailChange("CostPrice", e.target.value)
                  }
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.CostPrice === "" ? false : true}
                  helperText={errors.CostPrice}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={2} md={1.4} lg={0.9}>
                <TextField
                  fullWidth
                  label="LP.Rate"
                  size="small"
                  name="Lprate"
                  disabled
                  value={bufferObj?.Lprate}
                  onChange={(e) => handleDetailChange("Lprate", e.target.value)}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.Lprate === "" ? false : true}
                  helperText={errors.Lprate}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={2} md={1.4} lg={0.9}>
                <TextField
                  fullWidth
                  label="RSP"
                  size="small"
                  name="RSP"
                  disabled
                  value={bufferObj?.RSP}
                  onChange={(e) => handleDetailChange("RSP", e.target.value)}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.RSP === "" ? false : true}
                  helperText={errors.RSP}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={2} md={1.3} lg={0.9}>
                <TextField
                  fullWidth
                  label="RSP(VAT)"
                  size="small"
                  name="RSPWithVat"
                  disabled
                  value={bufferObj?.RSPWithVat}
                  onChange={(e) =>
                    handleDetailChange("RSPWithVat", e.target.value)
                  }
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.RSPWithVat === "" ? false : true}
                  helperText={errors.RSPWithVat}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={1.8} md={1.5} lg={1}>
                <TextField
                  fullWidth
                  label="Promo RSP"
                  size="small"
                  name="PromoRSP"
                   id="PromoRSP"
                  value={bufferObj?.PromoRSP}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, ""); // remove non-numeric

                    handleDetailChange("PromoRSP", value);
                    if (e.target.value === "") {
                      setBufferObj((prev) => ({
                        ...prev,
                        PromoRSPWithVat: 0,
                      }));
                    }
                  }}
                  onKeyUp={(e) => handlePromoRspKeyUp(e)}
                  onKeyDown={(e) => {
                    fKeyTabInput(e, "PromoRSPWithVat");
                  }}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.PromoRSP === "" ? false : true}
                  helperText={errors.PromoRSP}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={2} md={1.5} lg={1}>
                <TextField
                  fullWidth
                  label="PromoRSP(VAT)"
                  size="small"
                  name="PromoRSPWithVat"
                  id="promoRspUnitVAT"
                  value={bufferObj?.PromoRSPWithVat}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, ""); // remove non-numeric

                    handleDetailChange("PromoRSPWithVat", value);
                    if (value === "") {
                      setBufferObj((prev) => ({
                        ...prev,
                        PromoRSP: 0,
                      }));
                    }
                  }}
                  onKeyUp={(e) => handlePromoRspVATKeyUp(e)}
                  onKeyDown={(e) => {
                    fKeyTabInput(e, "CutPrice");
                  }}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.PromoRSPWithVat === "" ? false : true}
                  helperText={errors.PromoRSPWithVat}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={4} sm={2.1} md={1.3} lg={1}>
                <TextField
                  fullWidth
                  label="Cut.PR"
                  size="small"
                  id="CutPrice"
                  name="CutPrice"
                  value={bufferObj?.CutPrice}
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/[^0-9.]/g, "") // remove non-numeric
                      .replace(/(\..*?)\..*/g, "$1"); // allow only one dot

                    handleDetailChange("CutPrice", value);
                  }}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  error={errors.CutPrice === "" ? false : true}
                  helperText={errors.CutPrice}
                  onKeyDown={(e) => {
                    fKeyTabInput(e, "QtyPerPromotion");
                  }}
                  autoComplete="off"
                />
              </Grid>

              <Grid item xs={4} sm={2.1} md={1.3} lg={1}>
                <TextField
                  fullWidth
                  label="Qty/Inv"
                  size="small"
                  id="QtyInv"
                  name="QtyPerPromotion"
                  value={bufferObj?.QtyPerPromotion}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only positive numbers
                    if (
                      value === "" ||
                      (/^\d+$/.test(value) && Number(value) >= 0)
                    ) {
                      handleDetailChange("QtyPerPromotion", value);
                    }
                  }}
                  onFocus={fContent_Focus}
                  onBlur={(e) => {
                    if (e.target.value == "") {
                      setBufferObj((obj) => ({
                        ...obj,
                        QtyPerPromotion: 0,
                      }));
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      setTimeout(() => {
                        document.getElementById("CNType").focus();
                      }, 400);
                    }
                  }}
                  error={errors.QtyPerPromotion === "" ? false : true}
                  helperText={errors.QtyPerPromotion}
                  autoComplete="off"
                />
              </Grid>

              <Grid item xs={4} sm={3.2} md={2} lg={1.5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="cn-type-label">CN Type</InputLabel>
                  <Select
                    labelId="cn-type-label"
                    label="CN Type"
                    id="CNType"
                    name="CNType"
                    value={bufferObj.CNType}
                    onChange={(e) => {
                      handleDetailChange("CNType", e.target.value);
                      if (e.target.value === "-") {
                        setBufferObj((prev) => ({
                          ...prev,
                          CNAmount: 0,
                          VendorCd: "",
                          Vendor: "",
                        }));
                      }
                      setTimeout(() => {
                        document.getElementById("CNAmt").focus();
                      }, 400);
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                  >
                    {cnType.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4} sm={2.5} md={1.5} lg={1}>
                <TextField
                  fullWidth
                  label="CN.Amt"
                  size="small"
                  id="CNAmt"
                  name="CNAmount"
                  value={bufferObj?.CNAmount}
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/[^0-9.]/g, "") // remove non-numeric
                      .replace(/(\..*?)\..*/g, "$1"); // allow only one dot

                    handleDetailChange("CNAmount", value);
                  }}
                  onKeyUp={(e) => {
                    fKeyTabInput(e, "Vendor");
                  }}
                  onFocus={fContent_Focus}
                  onBlur={fContent_Blur}
                  disabled={bufferObj?.CNType === "-" ? true : false}
                  error={errors.CNAmount === "" ? false : true}
                  helperText={errors.CNAmount}
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={8} sm={5.8} md={5.4} lg={3.3}>
                <GCToggleSearchV1
                  xLabelText="Vendor"
                  xName="Vendor"
                  xType="text"
                  xValue={bufferObj?.Vendor}
                  xDisabled={bufferObj?.CNType === "-" ? true : false}
                  xReadOnly={false}
                  xOnChange={(e) => {
                    setBufferObj((prev) => ({
                      ...prev,
                      Vendor: e.target.value,
                    }));
                    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
                  }}
                  xOnKeyUp={fOnKeyUpVendor}
                  xonClickbtn={fOnKeyUpVendor}
                  xrows={sGC_Toggle_Head_Customer_GridData}
                  xcolumns={[
                    { field: "id", headerName: "ID", width: 70, hide: true },
                    { field: "AcCd", headerName: "Code", width: 100 },
                    { field: "Name1", headerName: "Name", flex: 1 },
                  ]}
                  xRowClick={(e) => {
                    setBufferObj((prev) => ({
                      ...prev,
                      VendorCd: e?.row?.AcCd,
                      Vendor: e?.row?.Name1,
                    }));
                    xfGC_Toggle_Head_Customer_Toggle();
                    setGC_Toggle_Head_Customer_ToggleDropDowm(false);

                    setTimeout(() => {
                      document.getElementById("PromoTyp").focus();
                    }, 400);
                  }}
                  xToggle={sGC_Toggle_Head_Customer_ToggleDropDowm}
                  xData={["Any", "Code", "Name"]}
                  xOnChangeDropdownInput={(e) => {
                    setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
                      ...obj,
                      [e.target.name]: e.target.value,
                    }));
                  }}
                  xDropdownObj={sGC_Toggle_Head_Customer_SearchDropdownObj}
                  xOnKeyUpDropdownInput={
                    fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                  }
                  xtabIndex="6"
                  xError={errors.Vendor === "" ? false : true}
                  xErrorMessage={errors.Vendor}
                />
              </Grid>
              <Grid item xs={4} sm={2.3} md={1.8} lg={1.3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="cn-type-label">Promo Type</InputLabel>
                  <Select
                    labelId="cn-type-label"
                    label="Promo Type"
                    id="PromoTyp"
                    name="PromoTyp"
                    value={bufferObj.PromoTyp}
                    onChange={(e) => {
                      handleDetailChange("PromoTyp", e.target.value);
                      setTimeout(() => {
                        document.getElementById("Remarks").focus();
                      }, 400);
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    error={errors.PromoTyp === "" ? false : true}
                    helperText={errors.PromoTyp}
                  >
                    {promoTyp.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={3.8} md={3.5} lg={3.5}>
                <TextField
                  fullWidth
                  label="Remarks"
                  size="small"
                  id="Remarks"
                  name="Remarks"
                  value={bufferObj?.Remarks}
                  onChange={(e) =>
                    handleDetailChange("Remarks", e.target.value)
                  }
                  autoComplete="off"
                />
              </Grid>
              <Grid
                item
                xs={8.5}
                sm={10.3}
                md={6.8}
                lg={7.4}
                textAlign={"right"}
              >
                <Button
                  variant="contained"
                  color="success"
                  onClick={fSave}
                  disabled={hasNonEnterStatus(data)}
                >
                  Save
                </Button>
              </Grid>
              <Grid item xs={2} sm={1} md={1} lg={0.6} textAlign={"right"}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "capitalize" }}
                  onClick={fNew}
                  disabled={hasNonEnterStatus(data)}
                >
                  New
                </Button>
              </Grid>
              <Grid
                item
                xs={1.2}
                sm={0.6}
                md={0.5}
                lg={0.3}
                textAlign={"right"}
              >
               <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
              </Grid>
            </Grid>

            {/* TABLE */}
         

<Box
  sx={{
    mt: 2,
    px: 1,
    py: 1,
    borderRadius: 2,
    border: `1px solid rgba(33, 150, 243, 0.3)`,
  }}
>
  <Box
    sx={{
        // CONTAINER & SCROLLBARS (match TableContainer)
        borderRadius: 0,
        height: 360, // DataGrid needs a fixed height to scroll internally
        overflow: "hidden", // round corners + hide row shadows overflow
        "& .MuiDataGrid-root": {
          border: "none !important",
          borderRadius: 0,
        },
        "& .MuiDataGrid-iconSeparator": {
          visibility: "hidden",
        },
        "& .MuiDataGrid-virtualScrollerRenderZone": {
          marginTop: "4px",
        },
        "& .MuiDataGrid-virtualScroller": {
          // custom scrollbars
          scrollbarWidth: "thin",
          scrollbarColor: "#c2e3faff transparent",
          "&::-webkit-scrollbar": {
            height: 8,
            width: 8,
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#4e8fbd",
            borderRadius: 4,
          },
        },
 
        // HEADER styling (match your TableHead)
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#0d73bbc2",
          color: "white",
          borderBottom: "none",
          borderRadius: 0,
          marginBottom: "4px",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
        },
 
        // CELL & ROW base styles (remove default borders)
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
          padding: "8px", // same as p:1
          bgcolor: "background.paper",
        },
 
        // “Card” rows with gap + shadow (simulate borderSpacing: "0 8px")
        "& .MuiDataGrid-row": {
          // space between rows
          margin: "4px 0",
          boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
          borderRadius: "12px",
          overflow: "hidden", // keep rounded corners clean
        },
 
        // Rounded first/last cell corners (like your Table)
        "& .MuiDataGrid-row .MuiDataGrid-cell:first-of-type": {
          borderTopLeftRadius: "12px",
          borderBottomLeftRadius: "12px",
        },
        "& .MuiDataGrid-row .MuiDataGrid-cell:last-of-type": {
          borderTopRightRadius: "12px",
          borderBottomRightRadius: "12px",
        },
 
        // Hover color + pointer cursor (like your TableRow hover)
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "pink !important",
          cursor: "pointer",
        },
 
        // Compact density ~ size="small"
        "& .MuiDataGrid-cellContent, & .MuiDataGrid-columnHeaderTitle": {
          lineHeight: 1.2,
        },
      }}>
    <DataGridPro
  rows={sDetailData || []}
  getRowId={(row) => row.RowId}
  columns={columns}
  apiRef={apiRef}
  rowHeight={40}
  headerHeight={42}
  onRowClick={(params) => handleRowClick(params.row)}
  disableColumnMenu
  disableRowSelectionOnClick
  disableColumnResize
  hideFooter
  sx={{
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "transparent",
          },
          "& .MuiDataGrid-main": {
            outline: "none",
          },
        }}
/>
  </Box>
 

</Box>

          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ItemSelectionModal;
